import { keyframes } from '@mui/material/styles'

// Soft entrance of page headers and cards.
export const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`
